<template>
	<div class="row">
		<div class="form-agent-search-results col-12" tabindex="-1" v-if="agentsToShow.length">
			<fieldset style="border:none">
				<legend class="sr-only">Agent advisors available within your Zip Code</legend>
				<ul>
						<li class="agent-advisor-card-wrapper" v-for="(item, index) in agentsToShow">
							<div role="group"  aria-label="Agent advisor">
								<div class="agent-advisor-radio form-group">
									<div class="radio-container">
										<input id="Form.AgentId" type="radio" v-bind:value="item.Id" name="Form.AgentId"/>
										<label for="Form.AgentId"></label>
									</div>
								</div>
								<div class="agent-advisor-content-wrapper">
									<img :src=item.Image :alt="item.Title + ' ' + item.Name" class="agent-advisor-image"></img>
									<div class="agent-advisor-content">
										<span class="agent-advisor-title">{{ item.Title }}</span>
										<h2 class="agent-advisor-name">{{ item.Name }}</h2>
										<div class="agent-advisor-tags">
											<span v-for="(tag, index) in item.Tags">{{ tag.Text }}</span>
										</div>
										<div class="agent-advisor-location" v-for="(office, index) in item.Offices">
											{{ office.Address1 }}<span v-if="office.Address2"> {{ office.Address2 }}</span>,
											{{ office.City }}, {{ office.State }} {{ office.Zipcode }}
										</div>
									</div>
								</div>
							</div>
						</li>
				</ul>
			</fieldset>
			<div class="form-agent-search-btn" role="button" tabindex="0" v-on:keydown.space="loadMoreAgents" v-on:keyup.enter="loadMoreAgents" v-on:click="loadMoreAgents" v-if="showMoreButton && agentsToShow.length">
				<span>Show More</span>
			</div>
		</div>


		<div class="form-agent-search-results--no-results form-agent-search-results col-12" v-if="!agentsToShow.length">
			<div class="agent-advisor-no-results">
				<div class="agent-advisor-blur">
					<div class="agent-advisor-card-wrapper" role="region" aria-label="Agent advisor">
						<div class="agent-advisor-radio form-group">
							<div class="radio-container">
								<input id="no-agent-1" name="no-agent-1" type="radio" disabled/>
								<label for="no-agent-1"></label>
							</div>
						</div>
						<div class="agent-advisor-content-wrapper">
							<div class="agent-advisor-image" style="background-image: url('/Content/images/Custom/agent-placeholder-01.jpg');"></div>
							<div class="agent-advisor-content">
								<span class="agent-advisor-title">Agent</span>
								<h2 class="agent-advisor-name">John Smith</h2>
								<div class="agent-advisor-tags">
									<span>ABCD</span>
								</div>
								<div class="agent-advisor-location">
									12345 Main St, Main City, ST 12345
								</div>
							</div>
						</div>
					</div>
					<div class="agent-advisor-card-wrapper" role="region" aria-label="Agent advisor">
						<div class="agent-advisor-radio form-group">
							<div class="radio-container">
								<input id="no-agent-2" name="no-agent-2" type="radio" disabled/>
								<label for="no-agent-2"></label>
							</div>
						</div>
						<div class="agent-advisor-content-wrapper">
							<div class="agent-advisor-image" style="background-image: url('/Content/images/Custom/agent-placeholder-02.jpg');"></div>
							<div class="agent-advisor-content">
								<span class="agent-advisor-title">Agent</span>
								<h2 class="agent-advisor-name">Jane Smith</h2>
								<div class="agent-advisor-tags">
									<span>ABCD</span>
								</div>
								<div class="agent-advisor-location">
									12345 Main St, Main City, ST 12345
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="agent-advisor-instructions">
					<p v-if="!isNoResultsFound">Please enter your zip code above to see nearby agents and advisors.</p>
					<p v-if="isNoResultsFound && isStateValid">No agents or advisors were found near you. Please enter a different zip code.</p>
					<p v-if="isNoResultsFound && !isStateValid">Please select a valid state and zip code above to see nearby agents and advisors.</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	//import SmoothScroll from 'smooth-scroll'; // never used
	import { debounce } from 'debounce';
	import Cookie from '../../../js/custom/utils/cookie';
	import axios from 'axios';
	import Validation from '../../../js/common/utils/validation';

	export default {
		data: function () {
			return {
				agents: [],
				agentsToShow: [],
				zipCode: null,
				pageSize: 4,
                pageIndex: 0,
                totalPages: undefined,
				showMoreButton: true,
				isNoResultsFound: false,
				isClient: undefined,
				isStateValid: true,
				validServiceStates: ['AZ', 'IA', 'ID', 'KS', 'MN', 'MT', 'ND', 'NE', 'NM', 'OK', 'SD', 'UT', 'WI', 'WY']
			}
		},
		computed: {
		},
		components: {
		},
		updated: function() {
			$('input[name="Form.AgentId"]').on('change', (e) => {
				let currentInput = $(e.currentTarget);
				this.toggleAgentCSSClass(currentInput);
			});
		},
		mounted: function () {
			this.zipCode = Cookie.getCookie('zipcode');
			let zipInput = $('.js-zipcode');
			let clientInput = $('input[name="Form.IsClient"]');
			let stateInput = $('#Form_StateCode');

			if (this.zipCode.length) {
				this.findAgentByZipCode(this.zipCode);
			}

			// Keep track of whether the user is a client or not.
			clientInput.on('change', (e) => {
				let answer = $(e.currentTarget).val();
				this.isClient = answer;
			});

			// Find Agents when user stops typing
			zipInput.on('keyup', (e) => {
				this.zipCode = zipInput.val();
				if (this.isClient === 'False' && !this.validateState(stateInput)) {
					// Service is unavailable so avoid AgentAPI calls - Reset to initial state.
					this.agents = [];
					this.agentsToShow = [];
					this.isStateValid = false;
					this.isNoResultsFound = true;
				} else {
					this.findAgentByZipCode(this.zipCode);
				}
			});

			// Keep track of the state value.
			// There is a very specific scenario where a zipcode has been entered but the state selection is invalid.
			// We want to trigger a search once the state is valid if a full zipcode remains.
			stateInput.on('change keyup', (e) => {
				if (!this.isStateValid && this.isClient === 'False' && this.validateState(stateInput)) {
					this.findAgentByZipCode(this.zipCode);
				}
			});
		},
		methods: {
			findAgentByZipCode: debounce(function(zipCode) {
				if (zipCode.length >= 5) {
					// Get agents
					this.agents = [];
					axios
						.get(`/api/agent?Zipcode=${zipCode}&MaxMiles=50&PageIndex=${this.pageIndex}&PageSize=${this.pageSize}`)
						.then(response => {
							this.agents = response.data;
							this.agentsToShow = this.agents.Items;
							this.totalPages = this.agents.TotalPages;

							this.isStateValid = true;
							if (!this.agents.length) {
								this.isNoResultsFound = true;
                                setTimeout(() => {
									if ( $('.form-agent-search-results')) {
										$('.form-agent-search-results')[0].focus();
									}
                                }, 1000);
							}
							else {
								this.isNoResultsFound = false;
								this.hasMoreAgentRecords();
							}
						});
				}
			}, 1000),
			getMoreRecords: debounce(function(zipCode) {
				axios
					.get(`/api/agent?Zipcode=${zipCode}&MaxMiles=50&PageIndex=${this.pageIndex}&PageSize=${this.pageSize}`)
					.then(response => {
						this.agents = response.data;
						this.agentsToShow.push.apply(this.agentsToShow, this.agents.Items);
						this.totalPages = this.agents.TotalPages;
						this.hasMoreAgentRecords();
					});
            }, 1000),
			loadMoreAgents: function(event) {
				event.preventDefault();
				if (this.showMoreButton === true) {
                    this.pageIndex += 1;
                    this.getMoreRecords(this.zipCode);
				}
			},
			toggleAgentCSSClass: function (elem) {
				if (elem.is(':checked')) {
					$('.agent-advisor-card-wrapper').removeClass('agent-advisor-card-wrapper--selected');
					elem.closest('.agent-advisor-card-wrapper').addClass('agent-advisor-card-wrapper--selected');
				}
				else {
					$('.agent-advisor-card-wrapper').removeClass('agent-advisor-card-wrapper--selected');
				}
			},
			hasMoreAgentRecords(){
                if (this.totalPages <= (this.pageIndex + 1)) {
                    this.showMoreButton = false;
                } else {
                    this.showMoreButton = true;
				}
                setTimeout(() => {
					if ( $('.form-agent-search-results')) {
						$('.form-agent-search-results')[0].focus();
					}
                }, 1000);
            },
			validateState(elem) {
				if (Validation.selectValidate(elem) && this.IsServiceAvailableinState(elem)) {
					return true;
				} else {
					return false;
				}
			},
			IsServiceAvailableinState(elem) {
				let stateCode = elem.val();
				return this.validServiceStates.includes(stateCode);
			}
        }
    }
</script>